import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FaSearch } from "react-icons/fa";
import { FiDelete } from "react-icons/fi";

const SearchBarWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  align-content: center;
`;

const SearchInput = styled.input`
  width: 100%;
  margin: 16px 10px;
  border: 1px solid white;
  border-radius: 8px;
  padding: 14px 0 14px 50px;
  font-size: 14px;
  font-family: ${({ theme }) => theme.fontFamily};
  line-height: 20px;
  -webkit-box-shadow: 0 0 9px -2px white;
  box-shadow: 0 0 9px -2px white;
  -moz-box-shadow: 0 0 9px -2px white;
  outline: none;
  background-color: #151e3d;
  color: white;

  &::placeholder {
    color: white;
    opacity: 0.7;
  }
`;

const SearchIcon = styled(FaSearch)`
  position: absolute;
  width: 22px;
  height: 22px;
  top: 30px;
  left: 20px;
  color: white;
`;

const ClearIcon = styled(FiDelete)`
  position: absolute;
  width: 22px;
  height: 22px;
  top: 30px;
  right: 20px;
  color: white;
  cursor: pointer;
`;

const SearchBar = ({ autoFocus, onClear, placeholder, onChange, value }) => {
  const searchInputRef = useRef(null);
  const defaultPlaceholder = "Type any keyword to search for games...";

  useEffect(() => {
    autoFocus && searchInputRef.current.focus();
  }, [autoFocus, searchInputRef]);

  return (
    <SearchBarWrapper>
      <SearchIcon />
      <SearchInput
        ref={searchInputRef}
        data-test="search-bar-input"
        placeholder={placeholder || defaultPlaceholder}
        value={value}
        onChange={onChange}
      />
      {value ? <ClearIcon onClick={onClear} /> : null}
    </SearchBarWrapper>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  onClear: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default SearchBar;
